import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  FilterChip: {
    display: 'flex',
    alignItems: 'center',
    '& > span': {
      marginLeft: theme.spacing(1),
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      '&.has-color': {
        display: 'flex'
      }
    }
  },
  cellDataWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& *': {
      maxWidth: 225,
      width: '100%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    '& span': {
      fontSize: theme.typography.pxToRem(12)
    }
  },
  modifyLink: {
    whiteSpace: 'nowrap',
    padding: theme.spacing(0),
    transition: 'all 0.3s ease-in-out',
    backgroundColor: 'transparent !important',
    fontWeight: theme.typography.fontWeightSemiBold,
    '&:hover': {
      color: theme.palette.secondary.main
    }
  },

  statusWrapper: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 1.7,
    marginLeft: theme.spacing(0.375),
    '& svg': {
      marginRight: theme.spacing(0.5),
      fontSize: theme.typography.pxToRem(20)
    },
    '&.complete': {
      color: theme.palette.success.main
    },
    '&.deleted, &.error': {
      color: theme.palette.error.main
    },
    '&.inprogress': {
      color: theme.palette.info.light
    }
  },
  downloadProgressWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000
  },
  progress: {
    width: 200,
    marginLeft: 35,
    height: 10,
    marginTop: theme.spacing(10),
    borderRadius: theme.spacing(1),
    '& .MuiLinearProgress-root': {
      height: 8,
      borderRadius: theme.spacing(1)
    }
  },
}))
